module.exports = __webpack_public_path__ + "img/person-list__bg.jpg?adf5eed08190a809f462d73d54ee1144";